import {
  Image,
  AspectRatio,
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Stack,
  Text,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import Container from "components/base/Container";

export const MotionAspectRatio = motion(AspectRatio);
export const MotionBox = motion(Box);
export const MotionButton = motion(Button);
export const MotionContainer = motion(Container);
export const MotionFlex = motion(Flex);
export const MotionGrid = motion(Grid);
export const MotionGridItem = motion(GridItem);
export const MotionImage = motion(Image);
export const MotionStack = motion(Stack);
export const MotionText = motion(Text);

export const viewAppearDefault = {
  hidden: { opacity: 0, y: 15, transition: { type: "easeOut", duration: 0.3 } },
  visible: { opacity: 1, y: 0, transition: { type: "easeIn", duration: 0.3 } },
};

export const staggeredAppear = {
  visible: { transition: { staggerChildren: 0.2 } },
};

export const slowStaggeredAppear = {
  visible: { transition: { staggerChildren: 0.8 } },
};

export const menuScaleHover = {
  normal: { scale: 1, transition: { type: "tween", duration: 0.4 } },
  hover: { scale: 1.1, transition: { type: "tween", duration: 0.4 } },
};

export const menuItemAppearRight = {
  hidden: { opacity: 0, x: "50%", zIndex: -30 },
  visible: {
    opacity: 1,
    x: 0,
    zIndex: 1,
    transition: { type: "easeIn", duration: 0.2, delay: 0.2 },
  },
};

export const menuItemAppearLeft = {
  hidden: { opacity: 0, x: "-50%", zIndex: -30 },
  visible: {
    opacity: 1,
    x: 0,
    zIndex: 1,
    transition: { type: "easeIn", duration: 0.2, delay: 0.2 },
  },
};

export const appearBelow = {
  hidden: { opacity: 0, y: 15, transition: { type: "easeOut", duration: 0.3 } },
  visible: { opacity: 1, y: 0, transition: { type: "easeIn", duration: 0.3 } },
};

export const appearBelowDelay = (delay) => ({
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay } },
});

export const springAppearBelow = {
  hidden: { opacity: 0, y: 75 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 176, damping: 26 },
  },
};

export const appearAbove = {
  hidden: { opacity: 0, y: -25 },
  visible: { opacity: 1, y: 0, transition: { type: "tween", duration: 0.4 } },
};

export const appearRight = {
  hidden: { opacity: 0, x: 25 },
  visible: { opacity: 1, x: 0, transition: { type: "tween", duration: 0.4 } },
};

export const appearLeft = {
  hidden: { opacity: 0, x: -25 },
  visible: { opacity: 1, x: 0, transition: { type: "tween", duration: 0.4 } },
};

export const fadeIn = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      type: "tween",
      duration: 0.8,
    },
  },
};

export const blogFadeIn = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { type: "tween", duration: 0.3, delay: 0.2 },
  },
};

export const quickFade = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { type: "tween", duration: 0.4 } },
};

export const clickMe = {
  clickMe: {
    scale: [1, 1.05, 1, 1.05, 1],
    transition: { type: "spring", yoyo: Infinity, repeatDelay: 2 },
  },
  rest: { scale: 1 },
  hovered: { scale: 1.1 },
};

export const fade = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      type: "tween",
      duration: 0.2,
    },
  },
};

export const navbarAnimation = {
  hidden: {
    opacity: 0,
    y: -192,
    transition: { type: "easeInOut", duration: 0.4 },
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "easeInOut", duration: 0.6 },
  },
};

export const appearCTARight = {
  hidden: { opacity: 0, x: 280 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { type: "tween", duration: 0.8 },
  },
};

export const scaleOut = {
  scaled: { scale: 1.1 },
  normal: { scale: 1, transition: { type: "tween", duration: 6 } },
};

export const hoverScaleVariants = {
  hovered: { scale: 1.05, transition: { type: "tween", duration: 0.5 } },
  regular: { scale: 1, transition: { type: "tween", duration: 0.5 } },
};
